import { IsEnum } from 'class-validator';

export enum MetodoPago {
  TARJETA = 'tarjeta',
  QR      = 'qr',
  ZIMPLE  = 'zimple',
}

export class IniciarPagoPublicoDto {
  @IsEnum(MetodoPago, { message: 'Método inválido. Opciones: tarjeta, qr, zimple' })
  metodo: MetodoPago;
}
